import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';
import { SessionStatusEnum, useClearSession, useLocations, useSession } from '@/hooks';
import { removeHoldEventPayload } from '@/utils/scanDates';

export const useScanType = () => {
  const { trigger: triggerClearSession } = useClearSession();
  const {
    clearSlots,
    eventId,
    selectedSku,
    selectedSlot,
    session,
    locationId,
    setErrorModal,
    isSlotsLoading,
  } = usePrenuvoStore(
    useShallow((state) => ({
      clearSlots: state.scan.methods.clearSlots,
      eventId: state.scan.eventId,
      selectedSku: state.scan.sku,
      selectedSlot: state.scan.slot,
      session: state.scan.session,
      locationId: state.scan.locationId,
      setErrorModal: state.ui.methods.setErrorModal,
      isSlotsLoading: state.ui.isSlotsLoading,
    })),
  );
  const { handleSkuChange, skus } = useLocations();
  const { sessionStatus, triggerRemoveHoldEvent } = useSession();

  const manageSkuChange = (changeSkuId: string) => {
    if (sessionStatus === SessionStatusEnum.INACTIVE) {
      handleSkuChange(Number(changeSkuId));
      return;
    }

    if (session?.skuId === +changeSkuId || changeSkuId === '') return;

    setErrorModal(
      `Changing Scan Type`,
      `If changing your scan type, you'll need to select a time and date again. Are you sure you want to continue?`,
      {
        action: () => {
          try {
            triggerRemoveHoldEvent(removeHoldEventPayload(eventId, selectedSlot?.machines[0]));
          } catch (error) {
            console.error('Error removing hold event', error);
          }
          triggerClearSession().then((res) => {
            if (res?.data?.clearSession) {
              clearSlots();
              handleSkuChange(Number(changeSkuId));
            }
          });
        },
        text: 'Continue',
      },
    );
  };

  return { skus, selectedSku, locationId, isSlotsLoading, manageSkuChange };
};
